module.exports = ".full-width {\n  width: 100%; }\n\n.tab_1 {\n  margin-left: 50px; }\n\n.tab_2 {\n  margin-left: 100px; }\n\n.tab_3 {\n  margin-left: 150px; }\n\n.tab_4 {\n  margin-left: 200px; }\n\n.tab_5 {\n  margin-left: 250px; }\n\n.tab_6 {\n  margin-left: 300px; }\n\n.tab_7 {\n  margin-left: 350px; }\n\n.ocultar {\n  display: none; }\n\n.mostrar {\n  display: block; }\n\nmd-tab-header {\n  background-color: #F2F2F2E6; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/modanamnesis/programasfuncionales/programasdetalle/programasdetalle.component.scss
// module id = ./src/app/consulta/modanamnesis/programasfuncionales/programasdetalle/programasdetalle.component.scss
// module chunks = main